import React from 'react'
import MultilineText from '@components/MultilineText'
import useTrackEcommerceEvent, {ECOMMERCE_EVENTS} from '@helpers/track/useTrackEcommerceEvent'
import useEffect from '@hooks/useEffect'
import {useTranslation} from 'next-i18next'
import InformativeStamps from 'src/components/InformativeStamps'
import Modifiers from './Modifiers'
import Track from './Track'

import styles from './styles.module.css'
const translatePrefix = 'order.products.productsContent.selectProduct.inner.details'

export default function Details(props) {
  const {product} = props
  const {t} = useTranslation('website')
  const trackEcommerceEvent = useTrackEcommerceEvent()

  const informativeStampsList = product?.informativeStamps
  useEffect(() => {
    trackEcommerceEvent(ECOMMERCE_EVENTS.VIEWCONTENT, {product})
  }, [product._id])

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h1 className={styles.name}>{product.name}</h1>
        <div className={styles.informativeStampsContainer}>
          <InformativeStamps stamps={informativeStampsList} iconOnly={false} />
        </div>
        <p className={styles.description}>
          <MultilineText>{product.description}</MultilineText>
          {product.maxPurchaseQuantity ? (
            <p>
              {`* ${t(`${translatePrefix}.maxPurchaseQuantity`, {
                max: product.maxPurchaseQuantity
              })}`}
            </p>
          ) : null}
        </p>
        <br />
        <Modifiers product={product} state={props.state} onChange={props.onChange} />
      </div>
      <Track productId={product._id} />
    </div>
  )
}
